/**
 * @fileoverview PUT handler for the "/apps/business/accounts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessAccountsCacheKeys } from "./constants";
import type { PutAppsBusinessAccountsProps, AppsBusinessAccountsResult } from "./types";

export const putAppsBusinessAccounts = reactQueryMutationAdapter(
  appsBusinessAccountsCacheKeys,
  (props: PutAppsBusinessAccountsProps): Promise<AppsBusinessAccountsResult> => {
    return fetch("/apps/business/accounts", "PUT", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
